module.exports = __webpack_public_path__ + "img/icon-view.4227b22b.svg";